import {ReactElement} from "react";
import {Body, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Button} from "@zendeskgarden/react-buttons";
import {toast} from "react-toastify";
import {useBulkDeletePayrollPositionsMutation} from "../../../../__generated__/generated_types";

interface PositionDeleteModalProps {
    close: (deleted: boolean) => void;
    positionIds: string[];
}

export function PositionDeleteModal(props: PositionDeleteModalProps): ReactElement {
    const [bulkDeletePositions, {loading: deleteLoading}] = useBulkDeletePayrollPositionsMutation({
        fetchPolicy: "no-cache"
    });

    function doDelete(positionIds: string[]): void {
        if(positionIds.length === 0) {
            return;
        }

        bulkDeletePositions({
            variables: {
                positionIds
            }
        }).then(() => {
            toast.success(`Deleted ${positionIds.length} Position${positionIds.length > 1 ? "s" : ""}.`);
            props.close(true);
        }).catch(() => {/* Do Nothing */});
    }

    return <Modal>
        <Header>Delete Position{props.positionIds.length > 1 ? "s" : ""}</Header>
        <Body>
            Are you sure you want to delete {props.positionIds.length} position{props.positionIds.length > 1 ? "s" : ""}?
            <p style={{marginTop: "0.5em", color: "var(--grey-500)", fontSize: "0.85rem"}}>
                Positions with assigned employees cannot be deleted.
            </p>
        </Body>
        <Footer>
            <FooterItem>
                <Button isBasic onClick={() => props.close(false)}>Cancel</Button>
            </FooterItem>
            <FooterItem>
                <Button isDanger disabled={deleteLoading} onClick={() => doDelete(props.positionIds)}>Delete</Button>
            </FooterItem>
        </Footer>
    </Modal>;
}
